const EN = {
  'outlander.interior.image-1.hotspot-1.label': 'Steering & Dashboard',
  'outlander.interior.image-1.hotspot-1.message': 'Steering and dashboard',
  'outlander.interior.image-1.hotspot-2.label': 'Climate Control',
  'outlander.interior.image-1.hotspot-2.message': 'Climate control',
  'outlander.interior.image-1.hotspot-3.label': 'Gearshift &\nCenter Console',
  'outlander.interior.image-1.hotspot-3.message': 'Gearshift and center console',
  'outlander.interior.image-1.hotspot-4.label': "Driver's seat",
  'outlander.interior.image-1.hotspot-4.message': "Driver's seat",

  'outlander.interior.image-2.hotspot-1.label': 'Leather Appointed Seats',
  'outlander.interior.image-2.hotspot-1.message': 'Leather appointed seats',
  'outlander.interior.image-2.hotspot-2.label': 'Seatbelts and Restraint Systems',
  'outlander.interior.image-2.hotspot-2.message': 'Seatbelts and restraint systems',
  'outlander.interior.image-2.hotspot-3.label': 'Active Safety Features',
  'outlander.interior.image-2.hotspot-3.message': 'Active safety features',
  'outlander.interior.image-2.hotspot-4.label': '2nd-Row Amenities',
  'outlander.interior.image-2.hotspot-4.message': '2nd-row amenities',

  'outlander.exterior.hotspot-1.label': 'Front Grille & Lighting',
  'outlander.exterior.hotspot-1.message': 'Front grille and lighting',
  'outlander.exterior.hotspot-2.label': 'Roof Features',
  'outlander.exterior.hotspot-2.message': 'Roof features',
  'outlander.exterior.hotspot-3.label': 'Entry & Starting System',
  'outlander.exterior.hotspot-3.message': 'Entry and starting system',
  'outlander.exterior.hotspot-4.label': 'Wheels & Tires',
  'outlander.exterior.hotspot-4.message': 'Wheels and tires',
  'outlander.exterior.hotspot-5.label': 'Rear Features',
  'outlander.exterior.hotspot-5.message': 'Rear features',
  'outlander.exterior.hotspot-6.label': 'Bumper & Skid Plate Styling',
  'outlander.exterior.hotspot-6.message': 'Bumper and skid plate styling',
  'outlander.exterior.hotspot-7.label': 'Liftgate & Fuel Filler',
  'outlander.exterior.hotspot-7.message': 'Liftgate and fuel filler',
  'outlander.exterior.hotspot-8.label': 'Side Mirrors & Door Handles',
  'outlander.exterior.hotspot-8.message': 'Side mirrors and door handles',
  'outlander.exterior.hotspot-9.label': 'Windows & Wipers',
  'outlander.exterior.hotspot-9.message': 'Windows and wipers',

  'tourController.interior': 'Interior',
  'tourController.exterior': 'Exterior',

  'outlander.blueprint.safety.tab-1': 'Curtains and seats',
  'outlander.blueprint.safety.tab-2': 'Front-row knee SRS airbag',
  'outlander.blueprint.safety.hotspot-1.label': 'Side curtain airbag',
  'outlander.blueprint.safety.hotspot-1.message': 'Side curtain airbag',
  'outlander.blueprint.safety.hotspot-2.label': 'Seat mounted\nside airbag',
  'outlander.blueprint.safety.hotspot-2.message': 'Seat mounted airbag',
  'outlander.blueprint.safety.hotspot-3.label': 'Front seat-mounted\ncentre airbag',
  'outlander.blueprint.safety.hotspot-3.message': 'Front seat-mounted centre airbag',
  'outlander.blueprint.safety.hotspot-4.label': 'Driver knee airbag',
  'outlander.blueprint.safety.hotspot-4.message': 'Driver knee airbag',
  'outlander.blueprint.safety.hotspot-5.label': 'Front passenger knee airbag',
  'outlander.blueprint.safety.hotspot-5.message': 'Front passenger knee airbag',

  'outlander.launcher.introduction': 'Click to ask anything about the 2026 Outlander',
}

export default EN
